/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 24.01.13, 13:55
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { Localize } from "../utils/Localize";

import { AbstractTextContentVO } from "./AbstractTextContentVO";
import { HTMLLinkFormatsVO } from "./HTMLLinkFormatsVO";
import { LocalizedTextVO } from "./LocalizedTextVO";

import { XML } from "@goodgamestudios/xml-e4x";

export class HTMLTextVO extends AbstractTextContentVO {
    public appendText: boolean = false;
    public maxChilds: number = 1;

    public linkFormats: HTMLLinkFormatsVO;

    private _localizedTextVOList: LocalizedTextVO[];

    // Holds ready composed HTML nodes
    private _htmlText: XML;

    public get localizedTextVOList(): LocalizedTextVO[] {
        return this._localizedTextVOList;
    }

    public addLocalizedTextVO(vo: LocalizedTextVO, triggerUpdate: boolean = false): void {
        if (!this._localizedTextVOList) {
            this._localizedTextVOList = [];
        }

        this._localizedTextVOList.push(vo);

        // Check if the maximum child amount has been reached. If the buffer is full the oldest (first) element will be deleted.
        while (this._localizedTextVOList.length > this.maxChilds) {
            this._localizedTextVOList = this._localizedTextVOList.slice(1, this._localizedTextVOList.length);
        }

        if (triggerUpdate) {
            this.appendText = true;
            this.propertyChangedSignal.dispatch();
        }
    }

    public dispose(): void {
        super.dispose();
        if (this._localizedTextVOList != null) {
            this._localizedTextVOList.forEach(entry => entry.propertyChangedSignal.removeAll());
            this._localizedTextVOList = null;
        }
    }

    public compose(): string {
        return Localize.htmlText(this);
    }
    public get localizedTextVO(): LocalizedTextVO {
        this._localizedTextVOList[0].propertyChangedSignal.add(this.onLocalizedTextVOChanged);

        return this._localizedTextVOList[0];
    }

    /**
     * Invalidate HTMLTextVO when the LocalizedTextVO has changed.
     * @param vo
     */
    private onLocalizedTextVOChanged = (): void => {
        this.propertyChangedSignal.dispatch();
    };

    public get htmlText(): XML {
        if (!this._htmlText) {
            this._htmlText = XML("<content></content>");
        }

        return this._htmlText;
    }

    public set htmlText(value: XML) {
        this._htmlText = value;
    }
}
